<template>
  <div>
    <breadcrumb-list>
      <breadcrumb-link view="Home" label="Home" />
      <breadcrumb-link view="PatientVerificationList" label="Patient Verifier" />
      <breadcrumb-link
        view="PatientVerificationDetail"
        label="Result"
        :params="{ id: $route.params.id }"
        :active="true"
      />
    </breadcrumb-list>
    <section class="container is-max-hd">
      <b-loading :active="loading" :is-full-page="false" />
      <PatientVerificationDetail
        v-if="verification"
        :verification="verification"
        :refreshing="refreshing"
        :error="error"
      />
      <b-message v-else-if="error" type="is-danger" :closable="false">{{ error }}</b-message>
    </section>
  </div>
</template>
<script>
import request from '../request';
import PatientVerificationDetail from '../components/PatientVerificationDetail.vue';
export default {
  name: 'PatientVerificationDetailView',
  components: { PatientVerificationDetail },
  data() {
    return { verification: null, loading: false, refreshing: false, error: '' };
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },
  methods: {
    async load() {
      const id = this.$route.params.id;
      this.verification = null;
      this.refreshing = false;
      this.loading = true;
      this.error = '';
      try {
        const resp = await request.get(`/patient-verifications/${id}`);
        if (this.$route.params.id !== id) return;
        this.verification = resp.data.patient_verification;
        this.loading = false;
        if (this.verification.status === 'pending' && this.verification.remote_id) {
          await this.refresh();
        }
      } catch (err) {
        if (this.$route.params.id === id) this.error = 'Verification not found or unavailable.';
      } finally {
        if (this.$route.params.id === id) this.loading = false;
      }
    },
    async refresh() {
      const id = this.$route.params.id;
      this.refreshing = true;
      this.error = '';
      try {
        const resp = await request.post(`/patient-verifications/${id}/refresh`);
        if (this.$route.params.id === id) this.verification = resp.data.patient_verification;
      } catch (err) {
        if (this.$route.params.id === id) {
          this.error =
            err.response?.data?.errors?.NOFIELD ||
            'Unable to retrieve the pending result. Reopen this result to try again.';
        }
      } finally {
        if (this.$route.params.id === id) this.refreshing = false;
      }
    },
  },
};
</script>
